export default function SmallArrowRight({
  width = 16,
  height = 16,
  className = '',
}: {
  readonly width?: number
  readonly height?: number
  readonly className?: string
}) {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.53046 12.5303L5.4698 11.4696L8.93947 7.99994L5.4698 4.53027L6.53046 3.46961L11.0608 7.99994L6.53046 12.5303Z"
        fill="#101010"
      />
    </svg>
  )
}
